import { AppNavigation } from "../components/AppNavigation";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { 
  Lightbulb, 
  TrendingUp, 
  Bookmark, 
  Eye,
  Sparkles,
  ArrowRight
} from "lucide-react";
import { Link } from "react-router-dom";

export const IdeasPage = ({ user, logout, token }) => {
  const features = [
    {
      icon: <Eye className="w-8 h-8" />,
      title: "Asesor IA",
      description: "Analiza la competencia y obtén recomendaciones personalizadas",
      path: "/advisor",
      color: "from-cyan-500/20 to-blue-500/20",
      available: true
    },
    {
      icon: <TrendingUp className="w-8 h-8" />,
      title: "Trends",
      description: "Descubre tendencias, genera hashtags y encuentra los mejores horarios",
      path: "/ideas/trends",
      color: "from-purple-500/20 to-pink-500/20",
      available: true
    },
    {
      icon: <Bookmark className="w-8 h-8" />,
      title: "Colecciones",
      description: "Guarda y organiza ideas para futuros contenidos",
      path: "/ideas/collections",
      color: "from-orange-500/20 to-yellow-500/20",
      available: true
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      <AppNavigation user={user} logout={logout} />
      
      <main className="lg:ml-64 pt-14 lg:pt-0 pb-20 lg:pb-0">
        <div className="p-6 max-w-6xl mx-auto">
          {/* Header */}
          <div className="mb-8">
            <div className="flex items-center gap-3 mb-2">
              <div className="p-2 rounded-lg bg-gradient-to-br from-primary/20 to-accent/20">
                <Lightbulb className="w-6 h-6 text-primary" />
              </div>
              <h1 className="text-3xl font-bold">Ideas</h1>
            </div>
            <p className="text-muted-foreground">
              Encuentra inspiración, analiza tendencias y descubre qué funciona en tu nicho
            </p>
          </div>

          {/* Features Grid */}
          <div className="grid md:grid-cols-3 gap-6">
            {features.map((feature) => (
              <Card 
                key={feature.title}
                className={`relative overflow-hidden transition-all hover:shadow-lg ${
                  !feature.available ? 'opacity-60' : ''
                }`}
              >
                <div className={`absolute inset-0 bg-gradient-to-br ${feature.color} opacity-50`} />
                <CardHeader className="relative">
                  <div className="mb-4 text-primary">
                    {feature.icon}
                  </div>
                  <CardTitle className="flex items-center gap-2">
                    {feature.title}
                    {!feature.available && (
                      <span className="text-xs bg-muted px-2 py-1 rounded-full text-muted-foreground">
                        Próximamente
                      </span>
                    )}
                  </CardTitle>
                  <CardDescription>{feature.description}</CardDescription>
                </CardHeader>
                <CardContent className="relative">
                  {feature.available ? (
                    <Button asChild className="w-full">
                      <Link to={feature.path}>
                        Explorar
                        <ArrowRight className="w-4 h-4 ml-2" />
                      </Link>
                    </Button>
                  ) : (
                    <Button disabled className="w-full">
                      Próximamente
                    </Button>
                  )}
                </CardContent>
              </Card>
            ))}
          </div>

          {/* AI Tip */}
          <Card className="mt-8 border-primary/20">
            <CardContent className="flex items-start gap-4 p-6">
              <div className="p-3 rounded-full bg-primary/10">
                <Sparkles className="w-6 h-6 text-primary" />
              </div>
              <div>
                <h3 className="font-semibold mb-1">Consejo IA</h3>
                <p className="text-muted-foreground text-sm">
                  Usa el Asesor IA para analizar qué contenido funciona mejor en tu industria. 
                  Te ayudará a identificar patrones y oportunidades de mejora.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </main>
    </div>
  );
};

export default IdeasPage;
